import React, { FunctionComponent } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Icon, Tooltip } from "@familyzone/component-library";
import { TextProps as ChakraTextProps } from "@chakra-ui/layout/dist/declarations/src/text";

interface Props extends Omit<ChakraTextProps, "colorScheme" | "styleConfig" | "variant"> {
  title: string;
  tooltip?: string;
}

export const SectionHeading: FunctionComponent<Props> = ({ title, tooltip, ...props }) => {
  return (
    <Flex alignItems="center" data-testid="section-heading" borderRadius="sm" p="sp12" backgroundColor="neutrals.20">
      <Text fontFamily="Poppins" fontSize="sm" fontWeight="medium" color="text.paragraph.regular" role="heading" {...props}>
        {title}
      </Text>
      {tooltip && (
        <Box ml={10}>
          <Tooltip label={tooltip} variant="dark">
            <Flex>
              <Icon
                bg="neutrals.100"
                borderRadius="round"
                p="sp2"
                color="neutrals.0"
                height="12px"
                width="12px"
                variant="solid"
                icon="fa-question"
                data-testid="section-heading-help-icon"
              />
            </Flex>
          </Tooltip>
        </Box>
      )}
    </Flex>
  );
};
